import React, { Component, useEffect, useState, useMemo } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  UncontrolledButtonDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
// import AdrEquipmentRemarksModalV3 from "./AdrEquipmentRemarksModalV3";
import EditOperatorsModalV3 from "./EditOperatorsModalV3";
import { ADR_EDIT } from "../../_constants/actionConstants";
import { MAX_COLUMNS } from "./utils/adrUtilsV3";
import classNames from "classnames";
import "../../_typedefs/adrV3TypeDefs.js";
import AdrEquipOperatorSnippetV3 from "./AdrEquipmentOperatorSnippetV3";
import { Draggable } from "react-beautiful-dnd";
import AddEquipmentModalV3 from "./AddEquipmentModalV3";
import AdrEquipmentRemarksModalV3 from "./AdrEquipmentRemarksModalV3";
import AlertModal from "../_common/AlertModal";

class AdrEquipmentSetRowV3 extends Component {
  state = {
    /** @type {EquipmentSetRowClient} */
    formData: {
      /** @type {import("../../_typedefs/adrV3TypeDefs.js").EquipmentHours} */
      equipmentHours: {},

      // MULTIPLE OPERATORS: FOR FUTURE USE
      // /** @type {Object.<number, number[]>} */
      // operators: {},
    },
    showAddEquipmentModal: false,
    showEditOperatorsModal: false,
    showEquipmentRemarksModal: false,
    showAlert_cannotDeleteTaEquip: false,
  };

  componentDidMount() {
    const { equipmentSetRow } = this.props;
    const formData = {
      equipmentHours: _.cloneDeep(equipmentSetRow.equipmentHours),

      // MULTIPLE OPERATORS: FOR FUTURE USE
      // operators: _.cloneDeep(equipmentSetRow.operators),
    };

    this.setState({ formData });
  }

  componentDidUpdate(prevProps) {
    const { equipmentSetRow: currEsr } = this.props;
    const { formData } = this.state;

    // If col lengths are different, sniff out what's updated and reflect in the copy
    // of equipmentHours from above
    const prevEquipmentHourCols = Object.keys(prevProps.equipmentSetRow.equipmentHours);
    const currEquipmentHourCols = Object.keys(currEsr.equipmentHours);
    if (prevEquipmentHourCols.length !== currEquipmentHourCols.length) {
      // Create a deep copy of existing this.state.formData.equipmentHours to be edited
      let equipmentHours = _.cloneDeep(formData.equipmentHours);

      // MULTIPLE OPERATORS: FOR FUTURE USE
      // let operators = _.cloneDeep(formData.operators);

      // Check for any new cols
      currEquipmentHourCols.forEach((wpTabId) => {
        if (!prevEquipmentHourCols.includes(wpTabId)) {
          equipmentHours[wpTabId] = {
            ...currEsr.equipmentHours[wpTabId],
          };
          // MULTIPLE OPERATORS: FOR FUTURE USE
          // operators[wpTabId] = [...currEsr.operators[wpTabId]];
        }
      });

      // Check for any deleted cols
      prevEquipmentHourCols.forEach((wpTabId) => {
        if (!currEquipmentHourCols.includes(wpTabId)) {
          delete equipmentHours[wpTabId];
          // MULTIPLE OPERTORS: FOR FUTURE USE
          // if (operators[wpTabId]) delete operators[wpTabId];
        }
      });

      this.setState({ formData: { ...formData, equipmentHours } });

      // MULTIPLE OPERATORS: FOR FUTURE USE
      // this.setState({ formData: { ...formData, equipmentHours, operators } });
    }

    // Update equipmentHours. This would be otherwise unnecessary if not for
    // the externally-triggered updates from TentativeAgreements.
    for (const wpTabId in prevProps.equipmentSetRow.equipmentHours) {
      // If WP column was deleted, currLsr.equipmentHours[wpTabId] would not exist.
      if (!(wpTabId in currEsr.equipmentHours)) continue;
      const regHoursChanged =
        currEsr.equipmentHours[wpTabId].regHours !==
        prevProps.equipmentSetRow.equipmentHours[wpTabId].regHours;
      const otHoursChanged =
        currEsr.equipmentHours[wpTabId].otHours !==
        prevProps.equipmentSetRow.equipmentHours[wpTabId].otHours;
      if (regHoursChanged || otHoursChanged)
        this.setState({
          formData: {
            ...formData,
            equipmentHours: {
              ...formData.equipmentHours,
              [wpTabId]: {
                regHours: currEsr.equipmentHours[wpTabId].regHours,
                otHours: currEsr.equipmentHours[wpTabId].otHours,
              },
            },
          },
        });
    }
  }

  existsInTa = () => {
    const { tentativeAgreements } = this.props;
    const { equipmentId } = this.state.formData;
    return (tentativeAgreements || []).some(
      (ta) => ta.equipmentClient && equipmentId in ta.equipmentClient
    );
  };

  toggleAddEquipmentModal = () =>
    this.setState({ showAddEquipmentModal: !this.state.showAddEquipmentModal });

  toggleEditOperatorsModal = () =>
    this.setState({ showEditOperatorsModal: !this.state.showEditOperatorsModal });

  toggleEquipmentRemarksModal = () =>
    this.setState({ showEquipmentRemarksModal: !this.state.showEquipmentRemarksModal });

  toggleAlert_cannotDeleteTaEquip = () =>
    this.setState({
      showAlert_cannotDeleteTaEquip: !this.state.showAlert_cannotDeleteTaEquip,
    });

  handleChange_equipmentHours = (wpTabId, isOt) => (e) => {
    const { formData } = this.state;

    const timeType = isOt ? "otHours" : "regHours"; // property name
    this.setState(
      {
        formData: {
          ...formData,
          equipmentHours: {
            ...formData.equipmentHours,
            [wpTabId]: {
              ...formData.equipmentHours[wpTabId],
              [timeType]: e.target.value,
            },
          },
        },
      },
      this.props.markAdrDirty
    );
  };

  handleBlur_equipmentHours = (wpTabId, isOt) => (e) =>
    this.props.updateHours(wpTabId, { [isOt ? "otHours" : "regHours"]: e.target.value });

  handleClick_addNew = (e) => {
    e.preventDefault();
    this.toggleAddEquipmentModal();
  };

  handleClick_remarks = (e) => {
    e.preventDefault();
    this.toggleEquipmentRemarksModal();
  };

  handleClick_delete = (e) => {
    e.preventDefault();
    const { deleteRow, updateEquipmentIdsToDisable, markAdrDirty } = this.props;

    if (this.existsInTa()) {
      this.toggleAlert_cannotDeleteTaEquip();
    } else {
      updateEquipmentIdsToDisable();
      deleteRow();
      markAdrDirty();
    }
  };

  renderEquipmentHours = () => {
    const {
      equipmentSetRow,
      rowKey,
      wpSortOrder,
      workPerformedClient: wpc,
      status,
    } = this.props;
    const { formData } = this.state;

    let ehInputs = [];
    let colIndex = 0;

    wpSortOrder &&
      wpSortOrder.forEach((wpSo) => {
        const eh = equipmentSetRow.equipmentHours[wpSo.wpTabId] || null;
        const isIdle = wpc[wpSo.wpTabId] ? wpc[wpSo.wpTabId].isIdle : false;

        ehInputs.push(
          <div
            key={`equipHoursKey_${rowKey}_${colIndex}`}
            className={classNames("labor-equip-padding td-equip-hours", {
              "table-warning": isIdle,
            })}
          >
            <input
              className="form-control px-1"
              type="number"
              id={`equipHoursId_${rowKey}_${colIndex}`}
              name={`equipHours_${rowKey}_${colIndex}`}
              value={
                formData.equipmentHours[wpSo.wpTabId] &&
                formData.equipmentHours[wpSo.wpTabId].regHours !== null
                  ? formData.equipmentHours[wpSo.wpTabId].regHours
                  : ""
              }
              onChange={this.handleChange_equipmentHours(wpSo.wpTabId, false)}
              onBlur={this.handleBlur_equipmentHours(wpSo.wpTabId, false)}
              autoComplete="off"
              disabled={!eh || !equipmentSetRow.equipmentId || status.isReadOnly}
            />
          </div>
        );
        colIndex++;
      });

    if (colIndex < MAX_COLUMNS) {
      for (let remCol = colIndex; remCol < MAX_COLUMNS; remCol++) {
        ehInputs.push(
          <div
            key={`equipHoursKey_${rowKey}_${remCol}`}
            className="labor-equip-padding td-equip-hours"
          >
            <input
              className="form-control px-1"
              type="number"
              id={`equipHoursId_${rowKey}_${remCol}`}
              name={`equipHours_${rowKey}_${remCol}`}
              value={""}
              autoComplete="off"
              disabled={true}
            />
          </div>
        );
      }
    }

    return ehInputs;
  };

  renderEquipmentOvertimeHours = () => {
    const {
      equipmentSetRow,
      rowKey,
      wpSortOrder,
      workPerformedClient: wpc,
      status,
    } = this.props;
    const { formData } = this.state;

    let ehOtInputs = [];
    let colIndex = 0;

    wpSortOrder &&
      wpSortOrder.forEach((wpSo) => {
        const eh = equipmentSetRow.equipmentHours[wpSo.wpTabId] || null;
        const isIdle = wpc[wpSo.wpTabId] ? wpc[wpSo.wpTabId].isIdle : false;

        ehOtInputs.push(
          <div
            key={`equipOtHoursKey_${rowKey}_${colIndex}`}
            className={classNames("labor-equip-padding td-equip-hours", {
              "table-warning": isIdle,
            })}
          >
            <input
              className="form-control px-1"
              type="number"
              id={`equipOtHoursId_${rowKey}_${colIndex}`}
              name={`equipOtHours_${rowKey}_${colIndex}`}
              value={
                formData.equipmentHours[wpSo.wpTabId] &&
                formData.equipmentHours[wpSo.wpTabId].otHours !== null
                  ? formData.equipmentHours[wpSo.wpTabId].otHours
                  : ""
              }
              onChange={this.handleChange_equipmentHours(wpSo.wpTabId, true)}
              onBlur={this.handleBlur_equipmentHours(wpSo.wpTabId, true)}
              autoComplete="off"
              disabled={
                !eh || !equipmentSetRow.equipmentId || isIdle || status.isReadOnly
              }
            />
          </div>
        );
        colIndex++;
      });

    if (colIndex < MAX_COLUMNS) {
      for (let remCol = colIndex; remCol < MAX_COLUMNS; remCol++) {
        ehOtInputs.push(
          <div
            key={`equipOtHoursKey_${rowKey}_${remCol}`}
            className="labor-equip-padding td-equip-hours"
          >
            <input
              className="form-control px-1"
              type="number"
              id={`equipOtHoursId_${rowKey}_${remCol}`}
              name={`equipOtHours_${rowKey}_${remCol}`}
              value={""}
              autoComplete="off"
              disabled={true}
            />
          </div>
        );
      }
    }

    return ehOtInputs;
  };

  renderOperatorPreview = () => {
    const { workPerformedClient: wpc, projLaborList, equipmentSetRow } = this.props;

    /** @type {import("../../_typedefs/adrV3TypeDefs.js").EquipmentOperatorPreview[]} */
    let eoSnippetData = [];

    const equipmentHours = equipmentSetRow.equipmentHours || null;
    if (equipmentHours)
      for (const wpTabId in equipmentHours) {
        if (equipmentHours[wpTabId].operatorId) {
          const op = (projLaborList || []).find(
            (l) => l.laborId === equipmentHours[wpTabId].operatorId
          );
          eoSnippetData.push({
            equipmentId: equipmentSetRow.equipmentId,
            wpShortCaption: wpc[wpTabId].wpShortCaption,
            operatorId: equipmentHours[wpTabId].operatorId,
            fullName: op ? op.fullName : "(N/A)",
          });
        }
      }

    // MULTIPLE OPERATORS: FOR FUTURE USE
    // const operators = equipmentSetRow.operators;
    // if (operators) {
    //   for (const wpTabId in operators) {
    //     const ops = projLaborList
    //       .filter((l) => operators[wpTabId].includes(l.laborId))
    //       .map((o) => ({ operatorId: o.laborId, operatorFullName: o.fullName }));
    //     eoSnippetData.push({
    //       wpShortCaption: wpc[wpTabId].wpShortCaption,
    //       operators: ops,
    //     });
    //   }
    // }

    return <AdrEquipOperatorSnippetV3 snippetData={eoSnippetData} />;
  };

  renderEquipmentOvertimeRow = () => {
    return (
      <div className="d-flex flex-row flex-wrap esr-parent">
        <div className="labor-equip-padding td-equip-draghandle"></div>
        <div className="labor-equip-padding td-equip-contractor"></div>
        <div className="labor-equip-padding td-equip-number-desc"></div>
        <div className="labor-equip-padding td-equip-add"></div>
        <div className="labor-equip-padding td-equip-time-type">
          <span className="badge badge-warning px-1 mb-2">OT</span>
        </div>
        {this.renderEquipmentOvertimeHours()}
      </div>
    );
  };

  render() {
    const {
      projectId,
      tabId,
      equipmentSetRow,
      contractorOptions,
      equipmentOptions,
      equipmentIdsToDisable,
      updateEquipmentIdsToDisable,
      rowKey,
      rowIndex,
      toggleOvertimeRow,
      status,
      fetching,
      markAdrDirty,
    } = this.props;
    const {
      showAddEquipmentModal,
      showEditOperatorsModal,
      showEquipmentRemarksModal,
      showAlert_cannotDeleteTaEquip,
    } = this.state;
    return (
      <Draggable draggableId={rowKey} index={rowIndex}>
        {(provided) => (
          <div {...provided.draggableProps} ref={provided.innerRef}>
            <div className="d-flex flex-row flex-wrap esr-parent">
              <div className="labor-equip-padding td-equip-draghandle">
                <button
                  type="button"
                  id={`equipDragHandleId_${rowKey}`}
                  className="btn btn-light px-0"
                  disabled={status.isReadOnly}
                  {...provided.dragHandleProps}
                >
                  <FontAwesomeIcon icon="ellipsis-v" className="fa-fw" />
                </button>
              </div>
              {status.isReadOnly && !fetching ? (
                <AdrEquipmentSetRowV3_ContractorInput
                  rowKey={rowKey}
                  projectId={projectId}
                  contractorId={equipmentSetRow.contractorId}
                />
              ) : (
                <AdrEquipmentSetRowV3_ContractorSelect
                  rowKey={rowKey}
                  tabId={tabId}
                  projectId={projectId}
                  contractorId={equipmentSetRow.contractorId}
                  equipmentId={equipmentSetRow.equipmentId}
                  contractorOptions={contractorOptions}
                  markAdrDirty={markAdrDirty}
                  isDisabled={status.isReadOnly}
                />
              )}
              {status.isReadOnly && !fetching ? (
                <AdrEquipmentSetRowV3_EquipmentInput
                  projectId={projectId}
                  rowKey={rowKey}
                  equipmentId={equipmentSetRow.equipmentId}
                />
              ) : (
                <AdrEquipmentSetRowV3_EquipmentSelect
                  rowKey={rowKey}
                  tabId={tabId}
                  contractorId={equipmentSetRow.contractorId}
                  equipmentId={equipmentSetRow.equipmentId}
                  equipmentOptions={equipmentOptions}
                  equipmentIdsToDisable={equipmentIdsToDisable}
                  updateEquipmentIdsToDisable={updateEquipmentIdsToDisable}
                  markAdrDirty={markAdrDirty}
                  isDisabled={status.isReadOnly}
                />
              )}
              <div className="labor-equip-padding td-equip-add">
                <button
                  type="button"
                  name={`equipAdd_${rowKey}`}
                  id={`equipAddId_${rowKey}`}
                  className="btn btn-outline-secondary btn-equipment-add"
                  onClick={this.handleClick_addNew}
                  disabled={status.isReadOnly}
                >
                  <FontAwesomeIcon icon="tractor" className="fa-fw" />
                  <span className="equipment-add-plus px-0">
                    <strong>+</strong>
                  </span>
                </button>
              </div>
              <div className="labor-equip-padding td-equip-time-type">
                <span className="badge badge-info px-1 mb-2">RT</span>
              </div>
              {this.renderEquipmentHours()}
              <div className="labor-equip-padding td-equip-operator-preview">
                {this.renderOperatorPreview()}
              </div>
              <div className="td-equip-dropdown">
                <UncontrolledButtonDropdown
                  color="secondary"
                  disabled={status.isReadOnly}
                  className="float-right"
                >
                  <DropdownToggle caret>
                    <FontAwesomeIcon icon="ellipsis-h" />
                  </DropdownToggle>
                  <DropdownMenu container="body" right>
                    <DropdownItem header>For This Equipment...</DropdownItem>
                    <DropdownItem
                      onClick={this.toggleEditOperatorsModal}
                      disabled={!equipmentSetRow.equipmentId}
                    >
                      Add/Edit Operator(s)...
                    </DropdownItem>
                    {!equipmentSetRow.showOvertimeRow ? (
                      <DropdownItem onClick={toggleOvertimeRow}>
                        Show Overtime Row
                      </DropdownItem>
                    ) : (
                      <DropdownItem onClick={toggleOvertimeRow}>
                        Hide Overtime Row
                      </DropdownItem>
                    )}
                    <DropdownItem
                      onClick={this.handleClick_remarks}
                      disabled={!equipmentSetRow.equipmentId}
                    >
                      Remarks...
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem disabled>View Equipment Details...</DropdownItem>
                  </DropdownMenu>
                </UncontrolledButtonDropdown>
              </div>
              <div className="labor-equip-padding td-equip-delete">
                <button
                  type="button"
                  id={`deleteEquipWpr_${rowKey}`}
                  onClick={this.handleClick_delete}
                  className="btn btn-danger"
                  disabled={status.isReadOnly}
                >
                  <FontAwesomeIcon icon="times" className="fa-fw px-0" />
                </button>
              </div>
              {showAddEquipmentModal && (
                <AddEquipmentModalV3
                  projectId={projectId}
                  tabId={tabId}
                  rowKey={rowKey}
                  contractorId={equipmentSetRow.contractorId}
                  contractorOptions={contractorOptions}
                  markAdrDirty={markAdrDirty}
                  showAddEquipmentModal={showAddEquipmentModal}
                  toggleAddEquipmentModal={this.toggleAddEquipmentModal}
                />
              )}
              {showEquipmentRemarksModal && (
                <AdrEquipmentRemarksModalV3
                  projectId={projectId}
                  tabId={tabId}
                  rowKey={rowKey}
                  equipmentId={equipmentSetRow.equipmentId}
                  remarks={equipmentSetRow.remarks.remarks}
                  showModal={showEquipmentRemarksModal}
                  toggleModal={this.toggleEquipmentRemarksModal}
                  markAdrDirty={markAdrDirty}
                />
              )}
              {showEditOperatorsModal && (
                <EditOperatorsModalV3
                  projectId={projectId}
                  tabId={tabId}
                  rowKey={rowKey}
                  equipmentId={equipmentSetRow.equipmentId}
                  equipmentSetRow={equipmentSetRow}
                  markAdrDirty={markAdrDirty}
                  showEditOperatorsModal={showEditOperatorsModal}
                  toggleEditOperatorsModal={this.toggleEditOperatorsModal}
                />
              )}
              {showAlert_cannotDeleteTaEquip && (
                <AlertModal
                  alertKey={"esrCannotDeleteTaLabor"}
                  alertTitle={"Unable to Delete Equipment"}
                  alertTitleClass="bg-warning"
                  alertTitleIcon="exclamation-triangle"
                  alertText="This equipment entry is referenced in at least 1 TA(s) for this daily report. To delete, you must first remove this equipment entry from any TA that contains this labor entry."
                  acceptCaption={"OK"}
                  acceptClass={"danger"}
                  provideReject={false}
                  handleAlertAction={this.toggleAlert_cannotDeleteTaEquip}
                  showAlertModal={showAlert_cannotDeleteTaEquip}
                  toggleAlertModal={this.toggleAlert_cannotDeleteTaEquip}
                />
              )}
            </div>
            {equipmentSetRow.showOvertimeRow && this.renderEquipmentOvertimeRow()}
          </div>
        )}
      </Draggable>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateHours: (wpTabId, fields) =>
    dispatch({
      type: ADR_EDIT.EQUIPMENTSET.HOURS.UPDATE,
      tabId: ownProps.tabId,
      rowKey: ownProps.rowKey,
      wpTabId,
      fields,
    }),
  deleteRow: () =>
    dispatch({
      type: ADR_EDIT.EQUIPMENTSET.DELETE,
      tabId: ownProps.tabId,
      rowKey: ownProps.rowKey,
    }),
  toggleOvertimeRow: () =>
    dispatch({
      type: ADR_EDIT.EQUIPMENTSET.UPDATE,
      tabId: ownProps.tabId,
      rowKey: ownProps.rowKey,
      fields: { showOvertimeRow: !ownProps.equipmentSetRow.showOvertimeRow },
    }),
});

const mapStateToProps = (state, ownProps) => ({
  projLaborList: state.labors.projLaborLists[ownProps.projectId] || null,
  equipmentSetClient: state.adr.openAdrs[ownProps.tabId]
    ? state.adr.openAdrs[ownProps.tabId].equipmentSetClient || null
    : null,
  workPerformedClient: state.adr.openAdrs[ownProps.tabId]
    ? state.adr.openAdrs[ownProps.tabId].workPerformedClient || null
    : null,
  tentativeAgreements: state.adr.openAdrs[ownProps.tabId]
    ? state.adr.openAdrs[ownProps.tabId].tentativeAgreements || null
    : null,
});

export default connect(mapStateToProps, mapDispatchToProps)(AdrEquipmentSetRowV3);

function AdrEquipmentSetRowV3_ContractorInput(props) {
  const { rowKey, projectId, contractorId, equipmentId } = props;

  const projEquipList = useSelector(
    (state) => state.equipment.projEquipLists[projectId] || null
  );

  const projContractorList = useSelector(
    (state) => state.contractors.projContractorLists[projectId] || null
  );

  const ctrLabel = useMemo(() => {
    if (equipmentId) {
      const equip = (projEquipList || []).find((e) => e.equipmentId === equipmentId);
      const ctr = equip
        ? (projContractorList || []).find((pc) => pc.contractorId === equip.contractorId)
        : null;

      if (!ctr) return "(N/A)";

      const labelSuffix = ctr.isPrime ? "(P)" : ctr.isSupplier ? "(Supplier)" : "";
      return `${ctr.name || "(N/A)"} ${labelSuffix}`;
    } else {
      const ctr = (projContractorList || []).find(
        (pc) => pc.contractorId === contractorId
      );
      if (!ctr) return "(N/A)";

      const labelSuffix = ctr.isPrime ? "(P)" : ctr.isSupplier ? "(Supplier)" : "";
      return `${ctr.name || "(N/A)"} ${labelSuffix}`;
    }
  }, [projContractorList]);

  return (
    <div className="labor-equip-padding td-equip-contractor">
      <input
        name="contractorId"
        id={`equipContractorSelectId_${rowKey}`}
        value={ctrLabel}
        onChange={() => {}}
        className="form-control"
        disabled={true}
      />
    </div>
  );
}

function AdrEquipmentSetRowV3_ContractorSelect(props) {
  const {
    rowKey,
    tabId,
    projectId,
    contractorId: selectedContractorId,
    equipmentId: selectedEquipmentId,
    contractorOptions,
    isDisabled,
    markAdrDirty,
  } = props;

  const dispatch = useDispatch();

  const projEquipList = useSelector(
    (state) => state.equipment.projEquipLists[projectId] || null
  );

  const [selectedContractor, setSelectedContractor] = useState(
    (contractorOptions || []).find((co) => co.value === selectedContractorId) || null
  );

  useEffect(() => {
    if (selectedEquipmentId) {
      const equip =
        (projEquipList || []).find((e) => e.equipmentId === selectedEquipmentId) || null;
      setSelectedContractor(
        equip
          ? (contractorOptions || []).find((co) => co.value === equip.contractorId) ||
              null
          : null
      );
    } else {
      setSelectedContractor(
        (contractorOptions || []).find((co) => co.value === selectedContractorId) || null
      );
    }
  }, [contractorOptions, selectedContractorId, selectedEquipmentId, projEquipList]);

  const handleChange = (selected) => {
    if (selected.value === selectedContractorId) return;

    dispatch({
      type: ADR_EDIT.EQUIPMENTSET.UPDATE,
      tabId,
      rowKey,
      fields: { contractorId: selected.value, equipmentId: 0 },
    });

    markAdrDirty();
  };

  return (
    <div className="labor-equip-padding td-equip-contractor">
      <Select
        name="contractorId"
        id={`equipContractorSelectId_${rowKey}`}
        value={selectedContractor}
        onChange={handleChange}
        options={contractorOptions || []}
        menuPortalTarget={document.querySelector("body")}
        isDisabled={isDisabled}
      />
    </div>
  );
}

function AdrEquipmentSetRowV3_EquipmentInput(props) {
  const { projectId, rowKey, equipmentId } = props;

  const projEquipList = useSelector(
    (state) => state.equipment.projEquipLists[projectId] || null
  );
  const equipmentLabel = useMemo(() => {
    const _equip = (projEquipList || []).find((e) => e.equipmentId === equipmentId);
    if (!_equip) return "(N/A)";

    return _equip.numberMakeDesc || "(N/A)";
  }, [projEquipList]);

  return (
    <div className="labor-equip-padding td-equip-number-desc">
      <input
        name="equipmentId"
        id={`equipSelectId_${rowKey}`}
        value={equipmentLabel}
        className="form-control"
        onChange={() => {}}
        disabled={true}
      />
    </div>
  );
}

function AdrEquipmentSetRowV3_EquipmentSelect(props) {
  const {
    rowKey,
    tabId,
    equipmentIdsToDisable,
    updateEquipmentIdsToDisable,
    contractorId: selectedContractorId,
    equipmentId: selectedEquipmentId,
    equipmentOptions,
    markAdrDirty,
    isDisabled,
  } = props;

  const dispatch = useDispatch();

  const [selectedEquipment, setSelectedEquipment] = useState(
    (equipmentOptions || []).find((eo) => eo.value === selectedEquipmentId)
  );

  const filteredEquipmentOptions = useMemo(
    () =>
      selectedContractorId
        ? (equipmentOptions || []).filter(
            (eo) => eo.contractorId === selectedContractorId
          )
        : equipmentOptions || [],
    [selectedContractorId, equipmentOptions]
  );

  useEffect(() => {
    updateEquipmentIdsToDisable();

    setSelectedEquipment(
      (filteredEquipmentOptions || []).find((eo) => eo.value === selectedEquipmentId) ||
        null
    );
  }, [filteredEquipmentOptions, selectedEquipmentId]);

  const handleChange = (selected) => {
    if (selected.value === selectedEquipmentId) return;

    dispatch({
      type: ADR_EDIT.EQUIPMENTSET.UPDATE,
      tabId,
      rowKey,
      fields: { contractorId: selected.contractorId, equipmentId: selected.value },
    });

    markAdrDirty();
  };
  return (
    <div className="labor-equip-padding td-equip-number-desc">
      <Select
        name="equipmentId"
        id={`equipSelectId_${rowKey}`}
        value={selectedEquipment}
        options={filteredEquipmentOptions}
        isOptionDisabled={(option) => equipmentIdsToDisable.includes(option.value)}
        onChange={handleChange}
        placeholder="(Select an Equipment)"
        menuPortalTarget={document.querySelector("body")}
        isDisabled={isDisabled}
      />
    </div>
  );
}
